export const projectType = [
  {name: "Single" , value : "SINGLE"},
  {name: "EP" , value : "EP"},
  {name: "Album" , value : "ALBUM"}
]

export const servicesOption = [
  { name: "Mixing Only", value: "Mixing Only" },
  { name: "Mastering Only", value: "Mastering Only" },
  { name: "Mixing and Mastering", value: "Mixing and Mastering" },
];

export const agreementsList = [
  { name: "Artwork Agreement", value: "Artwork Agreement" },
  
  { name: "Producer Agreement", value: "Producer Agreement" },
  { name: "Music Video Agreement", value: "Music Video Agreement" },
  { name: "Side Artist Agreement", value: "Side Artist Agreement" },
  {
    name: "Remix Agreement",
    value: "Remix Agreement",
  },
  { name: "Publishing Split Form", value: "Publishing Split Form" },
];

export const sideArtistServices = [
  { name: "Recording Vocals", value: "Recording Vocals" },
  { name: "Co Producing", value: "Co Producing" },
  {name: "Other" , value : "Other"},
];

export const flatFee = [
  { name: "Non-Recoupable", value: "Non-Recoupable" },
  { name: "Recoupable", value: "Recoupable" },
];
export const MixingBearingCost = [
  { name: "Remixer", value: "Remixer" },
  { name: "Artist", value: "Artist" },
];
export const DisputeSettlment = [
  { name: "Arbitration", value: "Arbitration" },
  { name: "Litigation", value: "Litigation" },
];
export const PublishingSplit = [
  { name: "Yes", value: "Yes" },
  { name: "No", value: "No" },
];

export const usResident = [
  { name: "Yes", value: "yes" },
  { name: "No", value: "no" },
];

export const accountingOption = [
  { name: "Monthly", value: "monthly" },
  { name: "Quarterly", value: "quarterly" },
  { name: "Yearly", value: "yearly" },
  { name: "NA", value: "na" },
];

export const ClausesOptions = [
  {
    name: "representation",
    label:
      "Representation and Warranties (ensure the producer is free to enter and perform the contract and the performed job is free from other copyright claims)",
  },
  { name: "indemnification", label: "Indemnification" },
  { name: "notice", label: "Notice" },
  { name: "remedies", label: "Remedies" },
  { name: "entireContract", label: "Entire Contract" },
  { name: "independentContract", label: "Independent Contractor" },
];
export const SideArtistClausesOptions = [
  {
    name: "representation",
    label:
      "Representation and Warranties (ensure the producer is free to enter and perform the contract and the performed job is free from other copyright claims)",
  },
  { name: "indemnification", label: "Indemnification" },
  { name: "notice", label: "Notice" },
  { name: "remedies", label: "Remedies" },
  { name: "entireContract", label: "Entire Contract" },
  { name: "jurisdiction", label: "Jurisdiction" },
];
export const RemixClausesOptions = [
  {
    name: "representation",
    label:
      "Representation and Warranties (ensure the producer is free to enter and perform the contract and the performed job is free from other copyright claims)",
  },
  { name: "indemnification", label: "Indemnification" },
  { name: "notice", label: "Notice" },
  { name: "remedies", label: "Remedies" },
  { name: "entireContract", label: "Entire Contract" },
];
export const MusicVideoClausesOptions = [
  { name: "copyright", label: "Copyright and Ownership" },
  {
    name: "representation",
    label: "Warranties and Representations",
  },
  { name: "scheduleandlocation", label: "Schedule and Location" },
  { name: "termination", label: "Termination" },
  { name: "governmentlaw", label: "Government Law" },
  { name: "entireagreement", label: "Entire Aggrement" },
];
export const artworkClausesOptions = [
  { name: "copyright", label: "Copyright and Ownership" },
  {
    name: "representation",
    label: "Warranties and Representations",
  },
  { name: "termination", label: "Termination" },
  { name: "law", label: "Government Law" },
  { name: "entireagreement", label: "Entire Aggrement" },
];
